import CONTRATO_SUPERINTENDENTES from '@/graphql/querys/administracion/contratos/superintendente/contratoSuperintendentes.gql';
import CONTRATO_REMOVER_SUPERINTENDENTE from '@/graphql/mutations/administracion/contratos/contrato/superintendente/removerContratoSuperintendente.gql';
import AGREGAR_CONTRATO_SUPERINTENDENTE from '@/graphql/mutations/administracion/contratos/contrato/superintendente/agregarContratoSuperintendente.gql';

export default {
  methods: {
    async mixAgregarSuperintendente() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_SUPERINTENDENTE,
          variables: {
            superintendente: this.superintendente,
          },
          update: (store, { data: { agregarContratoSuperintendente } }) => {
            const query = {
              query: CONTRATO_SUPERINTENDENTES,
              variables: {
                idContrato: this.contratoId,
              },
            };
            const { contratoSuperintendentes } = store.readQuery(query);
            const contratoSuperintendentesCopia = contratoSuperintendentes.slice();
            contratoSuperintendentesCopia.push(agregarContratoSuperintendente);
            store.writeQuery({
              ...query,
              data: {
                contratoSuperintendentes: contratoSuperintendentesCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixRemoverSuperintendente() {
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: CONTRATO_REMOVER_SUPERINTENDENTE,
          variables: {
            id: this.superintendenteEliminar.id,
          },
          update: (store) => {
            const query = {
              query: CONTRATO_SUPERINTENDENTES,
              variables: {
                idContrato: this.superintendenteEliminar.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoSuperintendentes } = data;
            const index = contratoSuperintendentes
              .findIndex((superintendente) => superintendente.id
              === this.superintendenteEliminar.id);
            if (index !== -1) {
              contratoSuperintendentes.splice(index, 1);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
